import { BookingCardProdaText } from "./BookingCardProdaText";

export const BookingCardProdaRow = ({
  booking,
  vari = "BLUE",
}: {
  booking: BookingState;
  vari?: "GRAY" | "BLUE";
}) => {
  return (
    <>
      {booking.bookingAttributes
        .filter((x) => x.value)
        .map((x) => {
          return (
            <BookingCardProdaText
              vari={vari}
              key={x.productAttribute.id}
              pickedDto={x}
              bookingAttributes={booking.bookingAttributes}
            />
          );
        })}
    </>
  );
};
